




















































import { ElementStatus, ElementStatusType, Product } from '@/models'
import { orderBy } from 'lodash'
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ElementStatusFilesModal extends Vue {
  @Prop({ required: true, type: Object }) product: Product
  @Prop({ required: true, type: Object }) element: Element
  @Prop({ required: false, type: Array }) elementStatusFiles: ElementStatus[]

  get elementStatusTypes() {
    return orderBy(this.$store.state.elementStatusTypes, ['orderType'])
  }

  get elementStatusPhases() {
    const elementStatusPhases = this.$store.state.elementStatusPhases.filter((elementStatusPhase: ElementStatusType) =>
      elementStatusPhase.editorialProjectId === this.product.editorialProject &&
      elementStatusPhase.country === this.product.country)
    return orderBy(elementStatusPhases, ['orderPhase'])
  }

  hideModal() {
    this.$bvModal.hide('elementStatusFilesModal' + this.element.id)
  }

  public getTypesFromPhase(phase: string) {
    return this.elementStatusTypes.filter((item: ElementStatusType) => item.phase.elementStatusPhaseId === phase)
  }

  public getFilesFromPhase(phase: string) {
    if (!this.elementStatusFiles || !phase) {
      return []
    }
    return this.elementStatusFiles.filter((item: ElementStatus) => item.elementStatusType?.phase.elementStatusPhaseId === phase)
  }
}
